import { createContext, useContext } from 'react';

import type { FeaturesEnum } from '@/features/feature-management/types/features';
import type { FeatureSetting } from '@/features/feature-management/types/featureSetting';

export type FeatureContextValues = {
  features: FeatureSetting[];
  isRefetching: boolean;
  isFeatureEnabled: (featureIdentifier: FeaturesEnum) => boolean;
  getFeature: <T extends Omit<FeatureSetting, 'featureValues'>>(
    featureIdentifier: FeaturesEnum
  ) => T;
  refetch: () => void;
};

const defaultContextValues: FeatureContextValues = {
  features: [],
  isRefetching: false,
  isFeatureEnabled: () => false,
  getFeature: <T>() => ({}) as T,
  refetch: () => {}
};

export const FeatureContext =
  createContext<FeatureContextValues>(defaultContextValues);
export const useFeature = () => useContext(FeatureContext);
